<mat-dialog-content>
  <p translate="inbox/task-list/mass-actions/archive/question" [translateParams]="{ nb: data.number }"></p>
  <p
    *ngIf="isConfirmationVisible"
    class="confirmation"
    [innerHtml]="'inbox/task-list/mass-actions/archive/confirmation' | translate: { nb: data.number }"></p>

  <mat-slide-toggle
    *ngIf="isConfirmationVisible"
    [(ngModel)]="isConfirmationChecked"
    [class.confirmed]="isConfirmationChecked"
    data-testid="confirm-checkbox"
    ><span translate="inbox/task-list/mass-actions/archive/sure"></span
  ></mat-slide-toggle>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-raised-button
    type="button"
    color="primary"
    (click)="confirm()"
    [disabled]="isConfirmationVisible && !isConfirmationChecked"
    class="confirm"
    [class.confirmed]="isConfirmationChecked"
    data-testid="confirm-archive">
    <span
      translate="inbox/task-list/mass-actions/archive/confirm-button"
      [translateParams]="{ nb: data.number }"></span>
  </button>
  <button mat-raised-button type="button" (click)="cancel()"><span translate="cancel"></span></button>
</mat-dialog-actions>
